// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"4a854de0","713":"dfba2e1b"}[chunkId] + ".chunk.css";
};